<template>
  <div id="app_wrapper" :style="{backgroundImage:newspaper_info.n_type==2&&newspaper_info.background_img!=''?'url(' + newspaper_info.background_img + ')':'url('+require('../assets/tongwei/bg.png')+')'}">


    <div id="app">
      <Loading :random="this.randomPx" v-bind:class="{ 'u-hide': showSlide }"
        v-if="this.$route.meta.showLoad && !keep" />

      <!--生成图片遮罩-->
      <div class="g-layer" v-show="layerShow">
        <div class="g-layerTips" v-show="!imgShow">
          <img src="../assets/timg.gif" alt />
          图片生成中....
        </div>
        <div class="g-layerPicture" v-show="imgShow">
          <img :src="imgUrl" alt class="m-GeneratePicture" />
          <p>长按图片保存</p>
          <a href="javascript:void(0)" @click="closeLayer">关闭</a>
        </div>
      </div>

      <!-- 日历遮罩 -->
      <div class="g-laydateCover" v-show="showLaydateCover" @click="isShowLaydate"></div>

      <a href="javascript:void(0)" style="position: fixed; right: 10px; bottom: 15px; z-index: 9999999"
        v-if="returnShow">
        <img src="../assets/return.png" alt class="g-return" style="width: 1.4rem; height: 1.4rem" @click="goBack" />
      </a>
      <swiper :options="swiperOption" ref="mySwiper" v-show="showSlide">
        <swiper-slide v-if="newspaper_info.n_type == 2 && newspaper_info.cover_img != ''"
          :style="{ backgroundImage: 'url(' + newspaper_info.cover_img + ')' }" class="g-cover">

        </swiper-slide>


        <swiper-slide v-for="(item, index) in data" :key="index" :id="'swiper' + index"
          :class="item.show_type == 20 ? 'nopadding' : ''">
          <!-- 通威版面 通威集团 -->
          <div class="g-flex">
            <Twtop v-bind:data="{ time: date, data: item, newspaper_info: newspaper_info }" />
            <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"
              v-bind:showCoverImg="layerShow" />
            <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId" />
            <TWbottom v-bind:data="item" v-bind:dom="'swiper' + index" @func="getImgForm" @isShowLaydate="isShowLaydate"
              v-bind:index="index" :name="item.tag" v-bind:newspaper_info='newspaper_info' />
          </div>
          <!-- 通威版面 通威农牧 -->
          <!-- <div class="g-flex" v-else-if="index == 1">
          <Twtop
            v-bind:data="{ time_module: date, item: item }"
            name="通威农牧"
          />
          <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <TWbottom
            v-bind:data="item"
            v-bind:dom="'swiper' + index"
            @func="getImgForm"
            @isShowLaydate="isShowLaydate"
            v-bind:index="index"
            name="通威农牧"
          />
        </div> -->
          <!-- 通威版面 通威太阳能 -->
          <!-- <div class="g-flex" v-else-if="index == 2">
          <Twtop
            v-bind:data="{ time_module: date, item: item }"
            name="通威太阳能"
          />

          <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <TWbottom
            v-bind:data="item"
            v-bind:dom="'swiper' + index"
            @func="getImgForm"
            @isShowLaydate="isShowLaydate"
            v-bind:index="index"
            name="通威太阳能"
          />
        </div> -->
          <!-- 通威版面  永祥股份 -->
          <!-- <div class="g-flex" v-else-if="index == 3">
          <Twtop
            v-bind:data="{ time_module: date, item: item }"
            name="永祥股份"
          />

          <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <TWbottom
            v-bind:data="item"
            v-bind:dom="'swiper' + index"
            @func="getImgForm"
            @isShowLaydate="isShowLaydate"
            v-bind:index="index"
            name="永祥股份"
          />
        </div> -->
          <!-- 通威版面  通威新能源-->
          <!-- <div class="g-flex" v-else-if="index == 4">
          <Twtop
            v-bind:data="{ time_module: date, item: item }"
            name="通威新能源"
          />

          <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <TWbottom
            v-bind:data="item"
            v-bind:dom="'swiper' + index"
            @func="getImgForm"
            @isShowLaydate="isShowLaydate"
            v-bind:index="index"
            name="通威新能源"
          />
        </div> -->
          <!-- 通威版面  好主人宠物食品-->
          <!-- <div class="g-flex" v-else-if="index == 5">
          <Twtop
            v-bind:data="{ time_module: date, item: item }"
            name="好主人宠物食品"
          />

          <HeadNews type="2" v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <AllType v-bind:data="item" v-bind:index="index" v-bind:columnId="columnId"/>
          <TWbottom
            v-bind:data="item"
            v-bind:dom="'swiper' + index"
            @func="getImgForm"
            @isShowLaydate="isShowLaydate"
            v-bind:index="index"
            name="好主人宠物食品"
          />
        </div> -->
        </swiper-slide>
      </swiper>
      <img src="../assets/thrrow.png" alt class="u-thrrow" />
    </div>
  </div>
</template>

<script>
import Twtop from "../components/tongwei/Top.vue";
import HeadNews from "../components/tongwei/HeadNews.vue";
import AllType from "../components/tongwei/AllType.vue";
import TWbottom from "../components/tongwei/TWbottom.vue";

import Loading from "../components/Loading.vue";

import LayerAd from "../components/LayerAd.vue";
import wx from "weixin-js-sdk";

import * as swiperAni from "../js/swiper.animate.min.js";

export default {
  name: "app",
  components: {
    Loading,
    Twtop,
    HeadNews,
    TWbottom,
    AllType,
    LayerAd,
  },
  data() {
    const self = this;
    return {
      activeIndex: "",
      randomPx: 0,
      shareTitle: "",
      adLayer: {},
      totalPage: "",
      start_index: "",
      keep: false,
      countTimer: null,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        direction: "vertical",
        spaceBetween: 20,
        readCount: "",
        noSwipingClass: "u-historyBox",
        on: {
          slideChangeTransitionStart: function () {
            self.activeIndex = this.activeIndex;
            let shareTitle = self.data[this.activeIndex].articles[0].title;
            let pageDate = sessionStorage.getItem("n_date");
            if (self.data[this.activeIndex].hasOwnProperty("ads")) {
              self.$layer.iframe({
                content: {
                  content: LayerAd, //传递的组件对象
                  parent: self, //当前的vue对象
                  data: {
                    imgUrl: self.data[this.activeIndex].ads.image,
                    url: self.data[this.activeIndex].ads.url,
                  }, //props
                },
                area: ["85%", "auto"],
                title: "none",
              });
            }
            //阅读统计
            //  console.log(self.data[this.activeIndex])
            let pageId = self.data[this.activeIndex].page_id;
            clearTimeout(self.countTimer);
            self.countTimer = setTimeout(function () {
              self.newsPaperCounts(pageId);

            }, 1000);
            console.log(shareTitle);
            if (this.activeIndex > 1) {
              console.log(self.data);
              console.log(self.data[this.activeIndex]);
              console.log(this.activeIndex);
              let shareUrl =
                location.protocol +
                "//" +
                location.host +
                location.pathname +
                "?index=" +
                this.activeIndex +
                "&date=" +
                pageDate;
              console.log(shareUrl);
              self.wechat(shareTitle, "点击阅读,了解通威每一天", shareUrl);
            } else {
              let shareUrl =
                location.protocol +
                "//" +
                location.host +
                location.pathname +
                "?date=" +
                pageDate +
                "&index=" +
                this.activeIndex;
              self.wechat(shareTitle, "点击阅读,了解通威每一天", shareUrl);
            }

            clearTimeout(self.iTime);
          },
        },
      },
      data: {},
      showSlide: false,
      marketInfo: {},
      imgUrl: "",
      layerShow: false,
      imgShow: false,
      returnShow: false,
      date: "",
      showLaydateCover: false,
      id: "",
      columnId: "",
      newspaper_info: {}
    };
  },
  methods: {
    checkHistory() {
      return document.referrer;
      console.log(document.referrer);
    },
    goBack() {
      window.history.go(-1);
    },
    getImgForm(data) {
      let that = this;
      this.layerShow = true;
      this.imgUrl = data.imgUrl;
      let img = new Image();
      img.src = this.imgUrl;
      img.onload = function () {
        that.imgShow = true;
      };
    },
    closeLayer: function () {
      this.layerShow = false;
      this.imgShow = false;
    },
    wechat: function (title, desc, href) {
      let requestUrl =
        "/api/weichat/gen_wx_js_signature.json?s_url=" +
        location.href;
      this.$axios({
        method: "get",
        url: requestUrl,
      }).then((res) => {
        console.log(res);
        wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.nonceStr,
          signature: res.data.data.signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareQZone",
          ],
        });
        wx.ready(function () {
          let imageurl =
            "http://www.nbd.com.cn/corp/2019newspaper/a_img/tongweishare.png";
          wx.onMenuShareTimeline({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareAppMessage({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareQQ({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareQZone({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });
        });

        wx.error(function (res) {
          console.log(res);
        });
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    isShowLaydate() {
      this.showLaydateCover = !this.showLaydateCover;
    },
    closeDateAndLayer() {
      this.showLaydateCover = false;
      // layer.closeAll()
    },

    newsPaperCounts(pageId) {
      this.$axios({
        method: "post",
        url: "/api/newspapers/page_click_counts",
        data: {
          page_id: pageId,
        },
      });
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  // mounted() {
  //   // this.swiper.slideTo(30, 1000, false);
  // },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了

    console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(60, 1000, false);
    let pageIndex = this.getQueryString("index");

    this.swiper.slideTo(pageIndex, 1000, false);
    // if (JSON.parse(sessionStorage.getItem("index")) != null) {
    //   let pageIndex = JSON.parse(sessionStorage.getItem("index")).page;
    //   this.swiper.slideTo(pageIndex, 1000, false);
    //   window.sessionStorage.removeItem("index");
    // }
    let date = this.getQueryString("date") || "";
    let article_id = this.getQueryString("article_id") || "";
    let start_index = this.getQueryString("start_index") || ""; //开始截取的屏幕index
    // let preview = this.getQueryString("preview") || "";
    this.start_index = start_index;
    // console.log(getUrl)
    //ajax 获取数据
    let that = this;
    let n_date = this.$route.params.date;
    let preview = this.$route.query.preview
    console.log(n_date)
    let objParams = {}

    if (n_date == undefined) {
      objParams.publish_date = ''
    } else if (n_date.indexOf('-') > -1) {
      objParams.publish_date = n_date
    } else {
      objParams.id = n_date
    }



    // sessionStorage.setItem("n_date", n_date);//临时存储date
    this.$axios({
      method: "get",
      url: "https://rm.tongwei.com/api/newspapers/newspaper_info.json",
      params: Object.assign({}, { preview: preview }, objParams)
    }).then((res) => {
      let firstPage = this.getQueryString("firstPage");
      this.data = res.data.data.pages;
      console.log(this.data);
      this.date = res.data.data.time_module;
      this.columnId = res.data.data.column_id;
      this.newspaper_info = res.data.data.newspaper_info

      sessionStorage.setItem(
        "n_date",
        this.date.date.replace("年", "-").replace("月", "-").replace("日", "")
      );
      // this.plague_status = res.data.data.plague_status;
      this.$nextTick(function () {
        this.randomPx = "100%";
      });
      // this.readCount = res.data.data.read_count;
      // this.totalPage = res.data.data.articles.length;

      console.log(this.data[0]);
      let pageDate = sessionStorage.getItem("n_date");
      let shareUrl =
        location.protocol +
        "//" +
        location.host +
        location.pathname +
        "?date=" +
        pageDate;

      that.wechat(
        that.data[0].articles[0].title,
        "点击阅读,了解通威每一天",
        shareUrl
      );

      //首屏统计 和 广告
      that.newsPaperCounts(that.data[0].page_id);

      setTimeout(() => {
        this.showSlide = true;
        this.keep = true;
        if (that.data[0].hasOwnProperty("ads")) {
          that.$layer.iframe({
            content: {
              content: LayerAd, //传递的组件对象
              parent: that, //当前的vue对象
              data: {
                imgUrl: that.data[0].ads.image,
                url: that.data[0].ads.url,
              }, //props
            },
            area: ["85%", "auto"],
            title: "none",
          });
        }
      }, 500);
      if (JSON.parse(sessionStorage.getItem("index")) != null) {
        let pageIndex = JSON.parse(sessionStorage.getItem("index")).page;
        this.swiper.slideTo(pageIndex, 1000, true);
        window.sessionStorage.removeItem("index");
      }
    });
  },

  created(params) {
    this.checkHistory();
    if (this.checkHistory() != "") {
      this.returnShow = true;
    }
    //微信分享
    // document.cookie="username=John Smith; expires=Thu, 18 Dec 2043 12:00:00 GMT; path=/";
    // sessionStorage.setItem("temp", "obj");
    console.log(this.$route.meta.showLoad);
  },
  activated() {
    // if(this.$route.params.date  != sessionStorage.getItem("n_date")) {
    //      location.href = location.href+'/' + sessionStorage.getItem("n_date")
    // }
    // console.log(this.$route.meta.showLoad)
    // console.log(this.keep)
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

#app_wrapper {
  position: relative;
  height: 100%;
  background-image: url(../assets/tongwei/bg.png);
  background-size: 100% 100%;
  box-sizing: border-box;
  background-repeat: no-repeat;
}


* {
  margin: 0;
  padding: 0;
}

body {
  /* padding:.866667rem .533333rem; */
  // max-width: 10rem;
}

#app {
  // background: #fff;
  // padding: 0.266667rem 0.333333rem;
  box-sizing: border-box;
  width: 9rem;
  height: 16rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -8rem;
  margin-left: -4.5rem;
}

a {
  text-decoration: none;
}

body {
  font-family: "PingFang SC", "微软雅黑", "Source Han Sans CN", SimSun, Arial,
    "Microsoft YaHei", "Hiragino Sans GB", 宋体, Tahoma，arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;

  box-sizing: border-box;
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.g-flex {
  display: flex;
  display: -webkit-flex;
  /* Safari */
  height: 16rem;
  flex-direction: column;
  justify-content: space-between;
  /* width: 8.44rem; */
  padding: 0.266667rem 0.333333rem;
  box-sizing: border-box;
}

.u-thrrow {
  position: absolute;
  width: 0.4rem;
  height: 0.226667rem;
  left: 50%;
  margin-left: -0.2rem;
  bottom: -16px;
  animation: fade 1s infinite;
  z-index: 99999;
}

@keyframes fade {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@-webkit-keyframes fade

/* Safari 与 Chrome */
  {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.container {
  display: none;
}

// .g-twoNews,.g-oneNews {
//   .m-imgBox2, .m-imgBox3 {
//     height: 6.44rem;
//   }
// }
.g-oneNews {
  .m-imgBox {
    height: 6.1rem;
  }
}

.g-twoNews {
  .m-imgBox {
    height: 5.106667rem;
  }
}

.g-threeNews {
  .m-imgBox {
    height: 6rem;
  }
}

.g-fourNews {
  .m-imgBox {
    height: 4.666667rem;
  }
}

.u-full {
  width: 7.466667rem;
  height: 12.04rem;
  margin: 0 auto;
  display: block;
}

.u-half {
  width: 7.56rem;
  height: 5.986667rem;
  display: block;
  margin: 0 auto;
}

.g-adBg {
  background: #e1e1e1;
}

.u-halfv2 {
  width: 100%;
  height: 5.453333rem;
  display: block;
}

.g-vertical-on-third .g-adBox {
  .m-adBoxRight {
    width: 2.453333rem;
  }

  .m-adBoxLeft {
    width: 5.6rem;
  }
}

.g-adBox {
  overflow: hidden;

  .u-newsBox {
    height: 45%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .m-adBoxLeft {
    width: 4.266667rem;
    height: 11.76rem;
    float: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .u-titile {
      font-size: 0.373333rem;
      color: #000;
      line-height: 1.2;
      display: block;
    }

    .u-desc {
      font-size: 0.32rem;
      color: #6c6c6c;
    }
  }

  .m-adBoxRight {
    width: 3.866667rem;
    height: 11.76rem;
    float: right;

    img {
      max-width: 100%;
    }
  }
}

.u-halfv3 {}

.g-halfv2 {
  .m-imgBox {
    height: 4rem;
  }

  .u-halfv2 {
    height: 5.13333rem;
  }

  .g-textarear {
    height: 3.6rem;
  }
}

.g-one-third {
  .m-imgBox {
    height: 4rem;
  }

  .u-halfv2 {
    height: 4.56rem;
  }
}

.g-one-forth {
  .m-imgBox {
    height: 4rem;
  }

  .u-quarter {
    height: 3.533333rem;
  }
}

.m-adNews {
  p {
    font-size: 0.426667rem;
    color: #000;
  }
}

.g-one-six {
  .m-imgBox {
    height: 3.413333rem;
  }

  .u-oneSix {
    height: 2.333333rem;
  }
}

.g-one-eight {
  .u-oneEight {
    height: 2rem;
  }
}

.g-one-eightv2 {
  .m-imgBox {
    height: 5.68rem;
  }

  .u-oneEightv2 {
    width: 4.133333rem;
    height: 3.333333rem;
  }

  .g-newsType1 ul li {
    height: 3.33333rem;

    &:last-child {
      padding: 0;
    }
  }
}

.g-fastBox {
  .m-imgBox {
    height: 4.586667rem;
  }
}

.g-textarear {
  height: 9.333333rem;
  padding: 0.266667rem;
  box-sizing: border-box;
  background: #ececec;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  p {
    margin-bottom: 0.266667rem;
    text-align: justify;
    font-size: 0.346667rem;
    color: #6c6c6c;
  }

  b {
    display: block;
    font-size: 0.346667rem;
    text-align: center;
    color: #000000;
    margin-bottom: 0.266667rem;
  }
}

.swiper-slide {
  // padding: 0.266667rem 0.333333rem;
  background: #fff;
  box-sizing: border-box;
}

.g-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 99999999999;
}

.g-layerTips {
  text-align: center;

  img {
    width: 80%;
    display: block;
    margin: 0 auto;
  }
}

.m-GeneratePicture {
  width: 80%;
  display: block;
  margin: 0 auto;
}

.g-layerPicture {
  p {
    text-align: center;
    font-size: 0.35rem;
    margin: 0.4rem 0;
  }

  a {
    display: block;
    width: 2rem;
    height: 0.5rem;
    line-height: 0.5rem;
    border: 1px solid #000;
    text-align: center;
    margin: 0 auto;
    color: #000;
  }
}

.m-cover {
  position: relative;
}

.m-coverWatch {
  position: absolute;
  right: 0.3333rem;
  bottom: 18%;
}

// layer reset
.vl-notify.vl-notify-alert h2.vl-notice-title {
  display: none !important;
}

.vl-notify.vl-notify-main {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.vl-notify-mask {
  background-color: #000 !important;
  opacity: 0.5 !important;
}

.layui-laydate,
.layui-laydate-content table,
.layui-laydate-main {
  width: 100%;
  margin-bottom: 0;
}

//cover
.g-coverBg {
  background-size: 100% 100%;
  background-image: url("http://www.nbd.com.cn/corp/20200510img/cover.jpg");
  height: 100%;
  display: block;
  position: relative;
}

.nopadding {
  padding: 0 !important;
}

.u-coverTips {
  width: 1.386667rem;
  height: 1.533333rem;
  position: absolute;
  bottom: 0.666667rem;
  right: 0.933333rem;
  animation: tips 2s infinite;
}

@keyframes tips {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
  }
}

.g-laydateCover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 999;
}

.g-twTitle {
  font-size: 0.46rem;
  color: #333;
  text-align: center;
  display: block;
  margin-bottom: 0.4rem;
  font-weight: bolder;
}

.g-twDesc {
  color: #666;
  font-size: 0.32rem;
  line-height: 1.5;
  text-align: justify;
}

.m-box {
  padding-bottom: 0.2rem;
  margin-bottom: 0.2rem;
  border-style: solid;
  border-width: 0px 0px 1px 0px;
  border-color: #f0f0f0;
  position: relative;
  &:last-child {
    padding-bottom: 0;
    border: 0;
    margin-bottom: 0;
  }

  .g-twTitle {
    margin-bottom: 0.213333rem;
  }

  .g-twDesc {
    text-align: center;
  }
}

.u-halfbox {
  width: 48%;
  position: relative;
  padding-bottom: .3333rem;
  .g-twTitle {
    // text-align: left;
    font-size: 0.4rem;
  }

  .g-twDesc {
    text-align: center;
    font-size: 0.28rem;
  }
}

.u-spw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.u-hr {
  width: 1px;
  height: 1.853333rem;
  background: #f0f0f0;
}

.u-newsType3Ttitle {
  display: block;
}

.g-cover {
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
